import { render, staticRenderFns } from "./CanvasHints.vue?vue&type=template&id=3c49ee18&scoped=true"
import script from "./CanvasHints.vue?vue&type=script&lang=js"
export * from "./CanvasHints.vue?vue&type=script&lang=js"
import style0 from "./CanvasHints.vue?vue&type=style&index=0&id=3c49ee18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c49ee18",
  null
  
)

export default component.exports